import React from 'react';
import { motion } from 'framer-motion';
import { getImageUrl } from '../lib/api';
import { User } from 'lucide-react';

export default function PlayerCard({ player, index = 0 }) {
  const positionConfig = {
    'Torwart': { bg: 'bg-[#46C7FF]/15', text: 'text-[#46C7FF]', border: 'border-[#46C7FF]/20', color: '#46C7FF' },
    'Verteidiger': { bg: 'bg-green-400/15', text: 'text-green-400', border: 'border-green-400/20', color: '#4ade80' },
    'Stürmer': { bg: 'bg-[#CC0000]/15', text: 'text-[#CC0000]', border: 'border-[#CC0000]/20', color: '#CC0000' },
  };
  const posStyle = positionConfig[player.position] || { bg: 'bg-white/10', text: 'text-white/70', border: 'border-white/10', color: '#fff' };

  return (
    <motion.div
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ delay: index * 0.05, duration: 0.5 }}
      className="group relative bg-[hsl(0,0%,7%)] border border-white/6 rounded-xl overflow-hidden hover:border-[#46C7FF]/20 transition-colors duration-300"
      data-testid="player-card"
    >
      <div className="relative aspect-[3/4] overflow-hidden bg-[hsl(0,0%,5%)]">
        {player.photoUrl ? (
          <img
            src={getImageUrl(player.photoUrl)}
            alt={player.name}
            className="w-full h-full object-cover group-hover:scale-[1.05] transition-transform duration-700 ease-out"
            loading="lazy"
          />
        ) : (
          <div className="w-full h-full flex flex-col items-center justify-center bg-gradient-to-b from-[hsl(0,0%,8%)] to-[hsl(0,0%,5%)]">
            <User className="w-16 h-16 text-white/6" />
          </div>
        )}
        <div className="absolute top-0 right-0 p-3">
          <div className="text-4xl sm:text-5xl font-bold text-white/10 leading-none" style={{ fontFamily: 'Space Grotesk', textShadow: '0 2px 10px rgba(0,0,0,0.5)' }}>
            {player.number}
          </div>
        </div>
        <div className="absolute bottom-0 left-0 right-0 h-32 bg-gradient-to-t from-[hsl(0,0%,7%)] via-[hsl(0,0%,7%)]/90 to-transparent" />
        <div className="absolute bottom-0 left-0 right-0 h-[2px]" style={{ background: `linear-gradient(90deg, ${posStyle.color}, transparent)` }} />
      </div>
      <div className="px-4 pb-4 -mt-8 relative">
        <div className="inline-flex items-center gap-1 bg-black/80 backdrop-blur border border-white/10 rounded-md px-2 py-0.5 mb-2">
          <span className="text-[10px] text-white/40 font-mono-score">#</span>
          <span className="text-sm font-bold text-white font-mono-score">{player.number}</span>
        </div>
        <h3 className="text-sm sm:text-base font-bold text-white leading-tight mb-2" style={{ fontFamily: 'Space Grotesk' }}>
          {player.name}
        </h3>
        <div className="flex items-center gap-2">
          <span className={`text-[9px] font-bold px-2 py-0.5 rounded-full ${posStyle.bg} ${posStyle.text} ${posStyle.border} border uppercase tracking-wider`}>
            {player.position}
          </span>
          {player.shoots && (
            <span className="text-[10px] text-white/25">{player.shoots === 'Links' ? 'L' : 'R'}</span>
          )}
        </div>
        {player.bio && (
          <div className="overflow-hidden max-h-0 group-hover:max-h-24 opacity-0 group-hover:opacity-100 transition-all duration-500 ease-in-out">
            <p className="text-[11px] text-white/35 leading-relaxed mt-2 line-clamp-3">{player.bio}</p>
          </div>
        )}
      </div>
    </motion.div>
  );
}
